import { createContext } from 'react';

const context = createContext({ canBind: true });
const { Provider, Consumer } = context;

export { Provider, Consumer };
export default context;
